import * as Yup from "yup";

export const FormChangePasswordSchema = Yup.object().shape({
    currentPassword: Yup.string()
        .trim()
        .required("La contraseña actual es requerida"),
    newPassword: Yup.string()
        .trim()
        .min(6, "La nueva contraseña debe tener al menos 6 caracteres")
        .required("La nueva contraseña es requerida"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Las contraseñas no coinciden")
        .required("Confirma tu nueva contraseña"),
});
